<template>
  <div class="nav-wrap" :class="{ 'has-member-entry': !isMemberActive }">
    <!-- <div class="logo" v-if="!IS_PRIVATE">
      <div class="logo-content">
        <div class="title">人机合译平台</div>
        <div class="net">FYCAT.COM</div>
      </div>
      <img v-if="logoPng" :src="logoPng" />
      <img v-else src="static/logo_nav.png" />
    </div>
    <div class="logo is_private" v-else>
      <img :src="require(`./assets/images/${VUE_APP_LOGO}.png`)" />
    </div> -->
    <div class="logo" v-if="!IS_PRIVATE">
      <img v-if="logoPng" :src="logoPng" />
      <img v-else src="static/logo_nav.png" />
    </div>
    <div class="logo" v-else>
      <img src="static/logo_nav.png" />
    </div>
    <!--导航-右侧开始-->
    <div class="left-menu" :class="{ 'en-menu': $i18n.locale === 'en' }">
      <el-menu
        :default-active="defaultActive"
        class="el-menu-vertical-demo"
        :unique-opened="true"
      >
        <template v-for="item in getNavInfo">
          <template v-if="!item.children">
            <el-menu-item class="nav-item" :index="item.url">
              <router-link
                :to="item.url"
                class="nav-item-link"
                :sort="item.sort"
              >
                <i class="nav-icon" :class="item.icon" />
                <span class="nav-name">{{ getMenuName(item) }}</span>
                <span
                  v-if="item.name == '我的任务' && taskNums.unReadCount !== 0"
                  class="badge"
                  >{{ taskNums.unReadCount }}</span
                >
              </router-link>
            </el-menu-item>
          </template>
          <template v-if="item.children">
            <el-submenu :index="item.id.toString()" :sort="item.sort">
              <template slot="title">
                <i class="nav-icon" :class="item.icon" />
                <span class="nav-name">{{ getMenuName(item) }}</span>
              </template>
              <template v-for="data in item.children">
                <el-menu-item :index="data.url" class="nav-item sub-menu">
                  <router-link :to="data.url" class="nav-item-link">
                    <div class="sub-box">
                      <i class="nav-icon" :class="data.icon" />
                      <span class="nav-name">{{ getMenuName(data) }}</span>
                    </div>
                  </router-link>
                </el-menu-item>
              </template>
            </el-submenu>
          </template>
        </template>
      </el-menu>
    </div>
    <button
      type="button"
      class="member-entry"
      @click="$emit('open-member')"
    >
      <img :src="memberButtonIcon" alt="" />
      <strong>VIP会员</strong>
    </button>
    <!--导航-右侧结束-->
  </div>
</template>

<script>
import { checkImgExists } from "@/utils/index";
import { mapActions, mapState } from "vuex";

export default {
  name: "AsideNav",
  data() {
    return {
      IS_PRIVATE: IS_PRIVATE, // 是否独立部署
      VUE_PLATFORM_TYPE: VUE_PLATFORM_TYPE, // 平台版本
      logoPng: "", // 默认飞译图片
      VUE_APP_LOGO: VUE_APP_LOGO, // 独立部署名称
      IS_ONLINE_PRIVATE: IS_ONLINE_PRIVATE,
      memberButtonIcon: require("@/assets/imgs/payment/menu-vip-button-icon.png"),
    };
  },

  computed: {
    ...mapState({
      taskNums: (state) => state.taskNums,
    }),
    getNavInfo() {
      return this.$store.getters["layout/getNavInfo"] || [];
    },
    defaultActive() {
      return this.$route.path;
    },
    memberInfo() {
      return this.$store.getters["layout/getMemberInfo"] || {};
    },
    isMemberActive() {
      return this.memberInfo.active === true;
    },
  },
  mounted() {
    this.logoChange();
    this.getTaskNums();
  },
  methods: {
    ...mapActions(["getTaskNums"]),
    logoChange() {
      switch (this.VUE_PLATFORM_TYPE) {
        case "personal": // 通用版
          this.logoPng = require("./assets/images/pro_logo.png");
          break;
        case "mdeical": // 医疗版
          this.logoPng = require("./assets/images/yl_logo.png");
          break;
        case "campus": // 高校版
          this.logoPng = require("./assets/images/gx_logo.png");
          break;
        case "nation": // 民族版
          this.logoPng = require("./assets/images/mz_logo.png");
          break;
        case "demo": // 演示版本
          if (localStorage.myLogoPic && localStorage.myLogoPic !== "null") {
            checkImgExists(localStorage.myLogoPic)
              .then(() => {
                this.logoPng = localStorage.myLogoPic;
              })
              .catch(() => {
                this.logoPng = "";
              });
          } else {
            this.logoPng = "";
          }
          break;
        default:
          if (this.IS_ONLINE_PRIVATE) {
            this.logoPng = require(`./assets/images/${this.VUE_APP_LOGO}.png`);
          } else {
            this.logoPng = require("./assets/images/logo.png");
          }
          break;
      }
    },
    //获取导航信息
    setNavInfo() {
      let self = this;
      // if (process.env.VUE_APP_HOSPITAL !== "align") {
      self.$store.dispatch("layout/navInfo");
      // }else{
      //   let menuList = [
      //     {id: 7, name: "双语对齐", code: "alignment", icon: "termBankIcon", url: "/home/memory/alignment"},
      //     {id: 6, name: "记忆库", code: "memory_lib", icon: "memoryBankIcon", url: "/home/memory/memoryBank"}
      //   ];
      //   self.$store.dispatch('layout/set_nav_info', menuList);
      // }
    },
    getMenuName(menu) {
      if (this.$i18n.locale === "en") {
        return menu.nameEn;
      } else {
        return menu.name;
      }
    },
    handleMemory(item) {
      item.showChild = !item.showChild;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>

<style lang="less" scoped>
.badge {
  background-color: #ff4343;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  margin-left: 5px;
}
</style>
